import React from 'react';

export const VolLocElevationModal = {
  title: 'Elevation of the Volcano (m)',
  body: (
    <div>
      <p>
        The elevation of a volcano in meters (m) above sealevel.
      </p>
    </div>
  ),
};
